<template>
  <div
    class="input-style-box"
    :class="{'is-focus':isFocus,'is-required':isRequired}"
  >
    <div class="input-style-box--label">{{ label||"label占位" }}</div>
    <div class="input-style-box--content">
      <slot>
        <el-input
          v-model="testText"
          class="input-style-box--input"
          placeholder="获取焦点测试用例"
          @focus="handlerFocus"
          @blur="handlerBlur"
        />
      </slot>
      <img :src="ossPath + '/pages/home/icon_dropdown_fill.png'" alt="" class="dropdown-icon"
           :class="{ 'is-focus': isFocus }">
    </div>
    <!--<div class="input-style-box&#45;&#45;progress-bar">
      <div class="bar"></div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "inputStyleBox",
  props:{
    label:{
      type:String,
      default:"标题",
    },
    focusStatus: Boolean,//是否处于获取焦点状态
    isRequired: Boolean,// 是否必填（仅在label前展示红点）
  },
  data(){
    return {
      testText:"",
      isFocus:false,
    }
  },
  watch:{
    focusStatus(newVal){
      if(newVal !== this.isFocus) this.isFocus = newVal;
    },
  },
  methods:{
    handlerFocus(){
      this.isFocus = true;
      this.$emit("focusStatus",true);
    },
    handlerBlur(){
      this.isFocus = false;
      this.$emit("focusStatus",false);
    },
  }
}
</script>

<style scoped lang="scss">
$borderRadius:8px;
.input-style-box{
  box-sizing: border-box;
  display: inline-block;
  width: 195px;
  height: 90px;
  background: #FFFFFF!important;
  border-radius: $borderRadius;
  position: relative;
  z-index: 1;
  overflow: hidden;
  border: 1px solid #E3E3E3;
  transition: border .3s ease-in;
  &--label{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    margin-bottom: 4px;
    padding: 12px 20px 0;
    transition: ease 0.4s;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &.is-required &--label{
    &:before {
      content: '*';
      color: #FF4D01;
      margin-right: 4px;
    }
  }
  &--content{
    //min-height: 40px;
    //line-height: 40px;
    position: relative;
    /deep/ &>*{
      max-width: 100%;
    }
    .dropdown-icon {
      position: absolute;
      right: 19px;
      bottom: 24px;
      transform: rotate(0);
      transition: all .3s ease;
    }
    .is-focus {
      transform: rotate(180deg);
    }
  }
  /deep/ &--content-style{
    font-size: 22px;
    color: #333333;
    font-weight: 800;
  }
  &--input{
    /deep/ .el-input__inner{
      border-color: transparent;
      background-color: transparent;
      padding: 0;
      &::placeholder{
        font-weight: 400;
      }
    }
  }
  &--progress-bar{
    position: absolute;
    z-index: 1;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 3px;
    border-radius: inherit;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    overflow: hidden;
    .bar{
      transition: ease 0.4s;
      width: 100%;
      height: 100%;
      transform: translateX(-100%);
      border-radius: inherit;
      background-color: transparent;
      //background-color: #FF4D01;
    }
  }
  &.is-focus {
    border: 1px solid #141414;
  }
  /*&.is-focus &--label{
    color: #FF4D01;
  }*/
  /*&.is-focus &--progress-bar{
    .bar{
      transform: translateX(0);
      background-color: #FF4D01;
    }
  }*/
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/inputStyleBox/index.vue